/* eslint-disable no-unused-expressions,react/prop-types */
import { Card, Row, Col, Icon } from 'antd';
import React from 'react';
import _ from 'lodash';
import sc from 'styled-components';

import { HeaderSub, Text } from '../../views/typography';
import { GRAY, GRAY_LIGHT, BLUE, SUB_FONT_SIZE, MEDIA_SM, MEDIA_GT_SM } from '../../views/styleConstants';
import PageFrame from '../../views/PageFrame';
import Clamper from '../../views/ContentWidthClamper';
import NewWindowIcon from '../../views/NewWIndowIcon';

const StyledNWI = sc.div`
  position: absolute; 
  right: 3px;
  top: 1px;
  `;

const IMAGE_HEIGHT = 90;
const LABEL_HEIGHT = 100;
const TOTAL_HEIGHT = IMAGE_HEIGHT + LABEL_HEIGHT;
const StyledRow = sc(Row)`
min-height: ${TOTAL_HEIGHT}px;
.ant-card-cover {
  height: ${IMAGE_HEIGHT}px;
  border-bottom: 1px solid ${GRAY};
}
.ant-card-body {
  min-height: ${LABEL_HEIGHT}px;
    padding: 0.5rem;
  }
  margin-bottom: 16px;
  @media only screen and (max-width: 768px) {
    display: none;
  }
  @media only screen and (max-width: 992px) {
    margin-bottom: 0;
  }
`;

const StyledCard = sc(Card)`
position: relative;
@media only screen and (max-width: ${MEDIA_SM}) {
  display: none;
}
.ant-card-meta-title {
  color: ${BLUE};
  text-align: center;
  overflow: visible;
  text-overflow: initial;
  white-space: normal;
  font-size: 1.25rem;
  line-height: 100%;
  padding-top: 0.25rem;
  }
.ant-card-meta-description {
  font-size: ${SUB_FONT_SIZE};
  color: ${GRAY};
}
`;

const SmallCard = sc.div`{
  @media only screen and (min-width: ${MEDIA_GT_SM}) {
      display: none;
    }
  }
  border: 1px solid ${GRAY_LIGHT};
  margin-bottom: 0.5rem;
  padding: 0.666rem;
  h3 {
    color: ${BLUE};
    margin-bottom: 0;
  }
  p {
    margin-bottom: 0;
  }
  display: flex;
  flex-direction: row;
  width: 100%;
`;

const StyledIcon = sc(Icon)`
  font-size: 60px;
  margin-top: 1.5rem;
`;

const SubText = sc(Text)`
font-size: ${SUB_FONT_SIZE};
color: ${GRAY};
`;

const SmallIcon = sc(Icon)`
font-size: 20px;
padding: 3px;
margin-right: 1rem;
`;

const PAGINATION = 4;
const PAGINATION_MED = 2;
const PAGINATION_SM = 1;

function onOpenWindow(url) {
  window.open(url, '_blank');
}

const cleanStr = str => str.replace(/[^A-Z0-9]/ig, '_');


export default ({ pages, history }) => (
  <PageFrame>
    <Clamper>
      {_.chunk(pages, PAGINATION).map((pageset, c) => (
        <StyledRow gutter={({ md: 8, lg: 16 })} key={c}>
          {pageset.map(page => (
            <Col
              key={page.safeKey()}
              lg={24 / PAGINATION}
              md={24 / PAGINATION_MED}
              sm={24 / PAGINATION_SM}
            >
              <StyledCard
                hoverable
                cover={<StyledIcon type={page.icon} />}
                onClick={() => {
                  page.link ? onOpenWindow(page.link) : history.push(`/${page.key}`);
                }}
                data-id={`homeItem-${cleanStr(page.name)}`}
              >
                {page.link && <StyledNWI><NewWindowIcon size="medium" fillColor={GRAY_LIGHT} /></StyledNWI>}
                <Card.Meta
                  title={page.name}
                  description={page.description || ''}
                />
              </StyledCard>

            </Col>
          ))
          }
        </StyledRow>
      ))
      }
      {pages.map(page => (
        <SmallCard key={page.key} title={`small-${page.name}`}>
          <SmallIcon type={page.icon} />
          <div style={({ flexGrow: 1 })}>
            <HeaderSub>{page.name}</HeaderSub>
            <SubText>{page.description || ''}</SubText>
          </div>
        </SmallCard>
      ))
      }
    </Clamper>
  </PageFrame>
);
